export default __webpack_public_path__ + "/dist/images/599921.70b6896492cd69d18a9b8bd207c4cfdf.jpg";